
interface DictItemDto {
  label: string
  value: string | number
}


// 最新申请工种审核状态
export const lastApplyOccupationStatusList = [
    { label: '待审核', value: 0 },
    { label: '已通过', value: 1 },
    { label: '驳回', value: 2 },
    { label: '撤销', value: 3 },
]


// 最新申请工种审核状态 0:待审核 1:审核通过 2:审核驳回
export const auditStatusList = [
    { label: '待审核', value: 0 },
    { label: '审核通过', value: 1 },
    { label: '审核驳回', value: 2 },
]


// 投保状态 0待生效1保障中2不在保
export const policyStatusList = [
    { label: '保障中', value: 1 },
    { label: '不在保', value: 2 },
]

// 报案状态 0:待受理,1:处理中,2:已结案,3:已驳回,4:已撤销,5:已确认 6.保险垫付
export const reportStatusList = [
    { label: '待受理', value: 0 },
    { label: '处理中', value: 1 },
    { label: '已结案', value: 2 },
    { label: '已驳回', value: 3 },
    { label: '已撤销', value: 4 },
    { label: '已确认', value: 5 },
    { label: '保险垫付', value: 6 },
]


//  事故类型(1:意外,2:工伤)
export const accidentTypeList = [
    { label: '意外', value: 1 },
    { label: '工伤', value: 2 },
]


// 是否 (1:是,2:否)
export const flagList = [
    { label: '是', value: 1 },
    { label: '否', value: 2 },
]

export const superHurtTypeList = [
    { label: '是', value: 1 },
    { label: '否', value: 2 },
    { label: '身故', value: 3 },
]



// 上传材料(0:未上传,1:已上传)
export const isUploadedList = [
    { label: '未上传', value: 0 },
    { label: '已上传', value: 1 },
]

// 出险状态
export const accidentStatusList = [
    { label: '工作时间及工作岗位', value: 3 },
    { label: '工作时间及非工作岗位', value: 3 },
    { label: '非工作时间及工作岗位', value: 0 },
    { label: '非工作时间及非工作岗位', value: 2 },
    { label: '上下班途中', value: 4 },
]

// 治疗方式
export const treatmentMethodList = [
    { label: '门诊', value: 0 },
    { label: '住院', value: 1 },
]

// 出险原因
export const accidentCauseList = [
    { label: '扭伤', value: 0 },
    { label: '砸伤', value: 1 },
    { label: '压伤', value: 2 },
    { label: '摔伤', value: 3 },
    { label: '烫伤', value: 4 },
]

// 操作属性
export const operationTypeList = [
    { label: '加保', value: 0 },
    { label: '调整', value: 1 },
    { label: '断保', value: 2 },
]

// 交易类型 (1:公对公,2:卫星扫码,3:私对公,4:赠送)
export const payModeList = [
    { label: '公对公', value: 1 },
    { label: '微信扫码', value: 2 },
    { label: '私对公', value: 3 },
    { label: '赠送', value: 4 },
    { label: '转移', value: 5 },
]
